var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users"},[_c('p',{staticClass:"text-h5"},[_vm._v("Einstellungen")])])
}]

export { render, staticRenderFns }